import toast from "react-hot-toast";
import axios from "axios";
import moment from "moment";
import Api from "../BaseUrlConfigration/ApiConfig";
const baseURL = process.env.REACT_APP_BASE_URL;


export const isTrialEndedReadOnly = (schoolData, userData) => {
  const isTrial = schoolData?.isTrial || schoolData?.schoolId?.trialInfo?.isTrial || schoolData?.trialInfo?.isTrial;
  const trialEndDateStr = schoolData?.trialEndDate || schoolData?.schoolId?.trialInfo?.trialEndDate || schoolData?.trialInfo?.trialEndDate;
  const trialStatus = schoolData?.trialStatus || schoolData?.schoolId?.trialInfo?.trialStatus || schoolData?.trialInfo?.trialStatus;

  if (!isTrial || (userData?.role !== "School" && userData?.role !== "Teacher")) return false;
  
  if (trialStatus === "expired") return true;
  if (!trialEndDateStr) return false;

  const trialEndDate = moment(trialEndDateStr);
  const today = moment();
  const daysRemaining = Math.max(0, trialEndDate.diff(today, 'days'));
  return daysRemaining <= 0;
};

export const uploadFileToS3 = async (file) => {
  const API_URL = "/school/content/file";
  const formData = new FormData();
  formData.append("image", file); // Changed the key to 'video'

  try {
    const response = await axios.post(`${baseURL}${API_URL}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (response.data.statusCode === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(
      "Error uploading content:",
      error.response?.data || error.message,
    );
    throw error; // Re-throw the error to handle it in the calling function
  }
};

export const truncateText = (text, wordLimit) => {
  if (!text) return "N/A";
  const words = text.split(" ");
  if (words.length > wordLimit) {
    return words.slice(0, wordLimit).join(" ") + "...";
  }
  return text;
};

export const truncateTextbrowse = (text, wordLimit, charLimit = 30) => {
  if (!text) return "N/A";


  if (text.length <= charLimit) return text;


  const words = text.split(" ");
  let truncated = words.slice(0, wordLimit).join(" ");


  if (truncated.length > charLimit) {
    truncated = truncated.substring(0, charLimit).trim() + "...";
  } else {
    truncated += "..."; // Add ellipsis if original was longer
  }

  return truncated;
};

export const truncateTextNames = (text, wordLimit, charLimit = 10) => {
  if (!text) return "N/A";


  if (text.length <= charLimit) return text;


  const words = text.split(" ");
  let truncated = words.slice(0, wordLimit).join(" ");


  if (truncated.length > charLimit) {
    truncated = truncated.substring(0, charLimit).trim() + "...";
  } else {
    truncated += "..."; // Add ellipsis if original was longer
  }

  return truncated;
};




























export function convertTime(minutes) {
  const hours = Math.floor(minutes / 60); // Get the hours
  const remainingMinutes = minutes % 60; // Get the remaining minutes

  if (hours > 0 && remainingMinutes > 0) {
    return `${hours}h ${remainingMinutes}m`; // "Xh Ym"
  } else if (hours > 0) {
    return `${hours}h`; // Only hours
  } else {
    return `${remainingMinutes}m`; // Only minutes
  }
}

export function truncateEmail(email, maxLength) {
  if (email.length <= maxLength) {
    return email; // No truncation needed
  }

  const [username, domain] = email.split("@");


  const allowedUsernameLength = maxLength - domain?.length - 3; // 3 for "..."


  const truncatedUsername = username.slice(0, allowedUsernameLength) + "...";

  return `${truncatedUsername}@${domain}`;
}

export const uploadStudentCSV = async (file) => {
  const reader = new FileReader();
  const requiredKeys = ["firstname", "surname", "username", "email", "year"];

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {
      const text = e.target.result;

      const delimiters = [",", ";", "\t"];
      let delimiter = ",";
      let maxCount = 0;


      delimiters.forEach((d) => {
        const count = (text.split("\n")[0].match(new RegExp(d, "g")) || [])
          .length;
        if (count > maxCount) {
          maxCount = count;
          delimiter = d;
        }
      });

      const lines = text.split("\n").filter(Boolean);

      if (lines.length > 1) {
        const headers = lines[0]
          .split(delimiter)
          .map((header) => header.trim().toLowerCase().replace(/^"|"$/g, "")); // Remove surrounding quotes

        const hasRequiredHeaders = requiredKeys.every((key) =>
          headers.includes(key),
        );

        if (hasRequiredHeaders) {
          const data = [];
          const usernameCount = {}; // Object to track how many times a username has been used

          for (let i = 1; i < lines.length; i++) {
            const values = lines[i]
              .split(delimiter)
              .map((value) => value.trim().replace(/^"|"$/g, "")); // Remove quotes from values
            const record = {};

            headers.forEach((header, index) => {
              if (requiredKeys.includes(header)) {
                record[header] = values[index];
              }
            });

            if (record.year) {
              const year = parseInt(record.year, 10);
              if ([7, 8, 9].includes(year)) {
                record.group = 3;
              } else if ([10, 11, 12].includes(year)) {
                record.group = 4;
              }
            }


            let baseUsername;
            if (record.username) {
              baseUsername = record.username
                .toLowerCase()
                .replace(/[^a-z0-9]/gi, "");
            } else if (record.firstname && record.surname) {
              baseUsername = `${record.firstname}${record.surname}`
                .toLowerCase()
                .replace(/[^a-z0-9]/gi, "");
            }

            if (baseUsername && baseUsername.length > 15) {
              baseUsername = baseUsername.substring(0, 15); // Maximum username length
            }

            if (baseUsername) {
              let newUsername = baseUsername;

              if (usernameCount[baseUsername]) {
                usernameCount[baseUsername]++;
                newUsername = `${baseUsername}${usernameCount[baseUsername]}`;
              } else {
                usernameCount[baseUsername] = 1;
              }

              record.username = newUsername;
            }

            if (!record.email) {
              toast.error(`One of the records is missing an email.`);
              resolve([]);
              return;
            }

            data.push(record);
          }

          resolve(data);
        } else {
          const missingHeaders = requiredKeys.filter(
            (key) => !headers.includes(key),
          );
          reject(
            new Error(`Missing required headers: ${missingHeaders.join(", ")}`),
          );
        }
      } else {
        reject(new Error("No data found in the CSV"));
      }
    };

    reader.onerror = () => {
      reject(new Error("Failed to read file"));
    };

    reader.readAsText(file);
  });
};

export const uploadTeacherCSV = async (file) => {
  const reader = new FileReader();
  const requiredKeys = ["firstname", "surname", "email", "department"];

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {
      const text = e.target.result;


      const delimiters = [",", ";", "\t"];
      const delimiter = delimiters.find((d) => text.includes(d)) || ",";


      const lines = text.split("\n").filter(Boolean);

      if (lines.length > 1) {

        const originalHeaders = lines[0]
          .split(delimiter)
          .map((header) => header.trim());
        const normalizedHeaders = originalHeaders.map((header) => {
          const cleaned = header.toLowerCase().replace(/^"|"$/g, "");

          if (cleaned === "firstname" || cleaned === "firstname")
            return "firstname";
          if (cleaned === "surname" || cleaned === "surname") return "surname";
          return cleaned;
        });


        const hasRequiredHeaders = requiredKeys.every((key) =>
          normalizedHeaders.includes(key),
        );

        if (hasRequiredHeaders) {
          const data = [];

          for (let i = 1; i < lines.length; i++) {
            const values = lines[i]
              .split(delimiter)
              .map((value) => value.trim().replace(/^"|"$/g, ""));
            const record = {};

            normalizedHeaders.forEach((header, index) => {
              if (requiredKeys.includes(header)) {
                record[header] = values[index];
              }
            });


            if (!record.email) {
              toast.error(`One of the records is missing an email.`);
              resolve([]); // Return empty data
              return;
            }

            data.push(record);
          }

          resolve(data);
        } else {
          toast.error(`Missing required headers: ${requiredKeys.join(", ")}`);
          resolve([]); // Return empty data if required headers are missing
        }
      } else {
        toast.error("No data found in the CSV");
        resolve([]); // Return an empty array if there's no data
      }
    };

    reader.onerror = () => {
      toast.error("Failed to read file");
      reject(new Error("Failed to read file"));
    };

    reader.readAsText(file);
  });
};

export const uploadSchoolAdminCSV = async (file) => {
  const reader = new FileReader();
  const requiredKeys = ["firstname", "surname", "email", "department"];

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {
      const text = e.target.result;

      const delimiters = [",", ";", "\t"];
      const delimiter = delimiters.find((d) => text.includes(d)) || ",";

      const lines = text.split(/\r?\n/).filter(Boolean);

      if (lines.length > 1) {
        const headers = lines[0].split(delimiter).map((h) =>
          h
            .replace(/^\ufeff/, "") // remove BOM
            .replace(/^"|"$/g, "") // remove surrounding quotes
            .trim()
            .toLowerCase(),
        );

        const hasRequiredHeaders = requiredKeys.every((key) =>
          headers.includes(key),
        );

        if (!hasRequiredHeaders) {
          toast.error(`Missing required headers: ${requiredKeys.join(", ")}`);
          resolve([]);
          return;
        }

        const data = [];

        for (let i = 1; i < lines.length; i++) {
          const values = lines[i]
            .split(delimiter)
            .map((v) => v.replace(/^"|"$/g, "").trim()); // strip quotes

          const record = {};

          headers.forEach((header, idx) => {
            if (requiredKeys.includes(header)) {
              record[header] = values[idx] || "";
            }
          });

          if (!record.email) {
            toast.error(`Row ${i} is missing an email.`);
            resolve([]);
            return;
          }

          data.push(record);
        }

        resolve(data);
      } else {
        toast.error("No data found in the CSV");
        resolve([]);
      }
    };

    reader.onerror = () => {
      toast.error("Failed to read file");
      reject(new Error("Failed to read file"));
    };

    reader.readAsText(file);
  });
};

export const uploadParentCSV = async (file) => {
  const reader = new FileReader();
  const requiredKeys = ["firstname", "surname", "username", "email", "year"];

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {
      const text = e.target.result;

      const delimiters = [",", ";", "\t"];
      const delimiter = delimiters.find((d) => text.includes(d)) || ",";

      const lines = text.split(/\r?\n/).filter(Boolean);

      if (lines.length > 1) {
        const headers = lines[0].split(delimiter).map((h) =>
          h
            .replace(/^\ufeff/, "") // remove BOM
            .replace(/^"|"$/g, "") // remove surrounding quotes
            .trim()
            .toLowerCase(),
        );

        const hasRequiredHeaders = requiredKeys.every((key) =>
          headers.includes(key),
        );

        if (!hasRequiredHeaders) {
          toast.error(`Missing required headers: ${requiredKeys.join(", ")}`);
          resolve([]);
          return;
        }

        const data = [];

        for (let i = 1; i < lines.length; i++) {
          const values = lines[i]
            .split(delimiter)
            .map((v) => v.replace(/^"|"$/g, "").trim()); // strip quotes

          const record = {};

          headers.forEach((header, idx) => {
            if (requiredKeys.includes(header)) {
              record[header] = values[idx] || "";
            }
          });

          if (!record.email) {
            toast.error(`Row ${i} is missing an email.`);
            resolve([]);
            return;
          }

          data.push(record);
        }

        resolve(data);
      } else {
        toast.error("No data found in the CSV");
        resolve([]);
      }
    };

    reader.onerror = () => {
      toast.error("Failed to read file");
      reject(new Error("Failed to read file"));
    };

    reader.readAsText(file);
  });
};

export const uploadWorkerCSV = async (file) => {
  const reader = new FileReader();
  const requiredKeys = ["firstname", "surname", "username", "email", "year"];

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {
      const text = e.target.result;

      const delimiters = [",", ";", "\t"];
      const delimiter = delimiters.find((d) => text.includes(d)) || ",";

      const lines = text.split(/\r?\n/).filter(Boolean);

      if (lines.length > 1) {
        const headers = lines[0].split(delimiter).map((h) =>
          h
            .replace(/^\ufeff/, "")
            .replace(/^"|"$/g, "")
            .trim()
            .toLowerCase(),
        );

        const hasRequiredHeaders = requiredKeys.every((key) =>
          headers.includes(key),
        );

        if (!hasRequiredHeaders) {
          toast.error(`Missing required headers: ${requiredKeys.join(", ")}`);
          resolve([]);
          return;
        }

        const data = [];

        for (let i = 1; i < lines.length; i++) {
          const values = lines[i]
            .split(delimiter)
            .map((v) => v.replace(/^"|"$/g, "").trim());

          const record = {};

          headers.forEach((header, idx) => {
            if (requiredKeys.includes(header)) {
              record[header] = values[idx] || "";
            }
          });

          if (!record.email) {
            toast.error(`Row ${i} is missing an email.`);
            resolve([]);
            return;
          }

          data.push(record);
        }

        resolve(data);
      } else {
        toast.error("No data found in the CSV");
        resolve([]);
      }
    };

    reader.onerror = () => {
      toast.error("Failed to read file");
      reject(new Error("Failed to read file"));
    };

    reader.readAsText(file);
  });
};

export const constructQueryString = (obj) => {
  if (obj) {
    const queryString = Object.keys(obj)
      .filter(
        (key) => obj[key] !== "" && obj[key] !== null && obj[key] !== undefined,
      )
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`,
      )
      .join("&");
    return queryString;
  } else {
    return "";
  }
};

export const getQueryParams = (search) => {
  const params = new URLSearchParams(search);
  const queryObject = { categories: "", selectedGroup: "", searchkey: "" }; // Default keys with empty strings

  for (const [key, value] of params.entries()) {
    queryObject[key] = value ?? ""; // Ensures empty string for missing values
  }

  return queryObject;
};

export const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getGroupFromYear = (selectedYear) => {
  if (selectedYear === null || selectedYear === undefined || selectedYear === "") {
    return "";
  }
  let group = "";
  const yearStr = String(selectedYear).trim();
  if (["3", "4"].includes(yearStr)) {
    group = 1; // KS2 Lower
  } else if (["5", "6"].includes(yearStr)) {
    group = 2; // KS2 Higher
  } else if (["7", "8", "9"].includes(yearStr)) {
    group = 3; // KS3
  } else if (["10", "11"].includes(yearStr)) {
    group = 4; // KS4
  } else if (["14", "15"].includes(yearStr)) {
    group = 14; // College
  } else if (["18"].includes(yearStr)) {
    group = 18; // Post - 18
  }
  return group;
};

export const sendVideoShareApi = async (videosInput) => {
  try {
    let videos = [];
    if (Array.isArray(videosInput)) {
      videos = videosInput;
    } else if (videosInput && Array.isArray(videosInput?.video)) {
      videos = videosInput.video;
    } else if (videosInput && Array.isArray(videosInput?.videos)) {
      videos = videosInput.videos;
    } else if (videosInput && typeof videosInput === "object") {
      videos = [videosInput];
    } else if (videosInput && typeof videosInput === "string") {
      videos = [{ _id: videosInput }];
    }

    if (!videos || videos.length === 0) return;

    const firstVideo = typeof videos[0] === "object" ? videos[0] : null;
    const yearVal = Array.isArray(firstVideo?.year)
      ? firstVideo?.year?.[0]
      : firstVideo?.year || 10;
    const groupVal =
      Array.isArray(firstVideo?.group) && firstVideo?.group?.length > 0
        ? firstVideo?.group?.[0]
        : getGroupFromYear(yearVal);

    // If single video, send string ID. If multiple videos, send array of IDs.
    const videoIdPayload =
      videos.length === 1
        ? (firstVideo?._id || (typeof videos[0] === "string" ? videos[0] : firstVideo))
        : videos.map((v) => (typeof v === "object" ? v?._id : v)).filter(Boolean);

    if (!videoIdPayload || (Array.isArray(videoIdPayload) && videoIdPayload.length === 0)) {
      return;
    }

    await Api.post("/school/auth/video_share", {
      group: Number(groupVal) || 1,
      videoId: videoIdPayload,
      year: Number(yearVal) || 10,
    });
  } catch (error) {
    console.error("Error calling video_share API:", error);
  }
};

export const getOrdinalSuffix = (day) => {
  const j = day % 10;
  const k = day % 100;
  if (j === 1 && k !== 11) return "st";
  if (j === 2 && k !== 12) return "nd";
  if (j === 3 && k !== 13) return "rd";
  return "th";
};

export const formatWeekCommencingDate = (dateStr) => {
  if (!dateStr) return "";
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  let date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    if (typeof dateStr === "string") {
      const parts = dateStr.split(/[\/\-]/);
      if (parts.length === 3) {
        if (parts[0].length === 4) {
          date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        } else if (parts[2].length === 4 || parts[2].length === 2) {
          const year = parts[2].length === 2 ? 2000 + Number(parts[2]) : Number(parts[2]);
          date = new Date(year, Number(parts[1]) - 1, Number(parts[0]));
        }
      }
    }
  }
  if (isNaN(date.getTime())) return dateStr;
  const day = date.getDate();
  const suffix = getOrdinalSuffix(day);
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  return `w/c ${day}${suffix} ${month} ${year}`;
};

export const canUserEditClass = (classData, userData) => {
  // If no classData or empty object (creating new class or still loading), allow
  if (!classData || Object.keys(classData).length === 0 || !classData?._id) return true;

  // Standardize user data (handle payload wrapper or localStorage fallback)
  let user = userData?.payload ? userData.payload : userData;
  if (!user || Object.keys(user).length === 0) {
    try {
      const persistedAuth = localStorage.getItem("persist:auth");
      if (persistedAuth) {
        const parsedAuth = JSON.parse(persistedAuth);
        const storedUserData = parsedAuth?.userData ? JSON.parse(parsedAuth.userData) : null;
        user = storedUserData?.payload ? storedUserData.payload : storedUserData;
      }
    } catch (e) {
      // fallback ignore
    }
  }

  // Standardize user roles and types
  const roles = (Array.isArray(user?.role) ? user.role : [user?.role || ""])
    .map((r) => String(r || "").toLowerCase().trim());
  const accountType = String(user?.accountType || "").toLowerCase().trim();

  // 1. Account Owner / School role check
  const isAccountOwner =
    roles.includes("school") ||
    roles.includes("account owner") ||
    roles.includes("accountowner") ||
    roles.includes("superadmin") ||
    roles.includes("super admin") ||
    accountType === "school" ||
    accountType === "account owner" ||
    accountType === "accountowner" ||
    user?.isAccountOwner === true ||
    user?.isOwner === true;

  if (isAccountOwner) return true;

  // 2. School Admin role check
  const isSchoolAdmin =
    roles.includes("schooladmin") ||
    roles.includes("school admin") ||
    accountType === "school admin" ||
    accountType === "schooladmin";

  if (isSchoolAdmin) return true;

  // 3. Creator check
  const currentUserId = String(user?._id || user?.id || "").trim();

  // Explicit owner/creator flags on classData
  if (classData?.isOwner === true || classData?.owner === true || classData?.isCreator === true) {
    return true;
  }

  if (currentUserId) {
    const classTeacherId = String(classData?.teacherId?._id || classData?.teacherId || "").trim();
    const classSchoolAdminId = String(classData?.schoolAdminId?._id || classData?.schoolAdminId || "").trim();
    const classSchoolId = String(classData?.schoolId?._id || classData?.schoolId || "").trim();
    const classUserId = String(classData?.userId?._id || classData?.userId || "").trim();
    const classCreatedById = String(classData?.createdById?._id || classData?.createdById || "").trim();
    const classOwnerId = String(classData?.owner?._id || (typeof classData?.owner === "string" ? classData?.owner : "") || "").trim();

    if (
      (classTeacherId && currentUserId === classTeacherId) ||
      (classSchoolAdminId && currentUserId === classSchoolAdminId) ||
      (classSchoolId && currentUserId === classSchoolId) ||
      (classUserId && currentUserId === classUserId) ||
      (classCreatedById && currentUserId === classCreatedById) ||
      (classOwnerId && currentUserId === classOwnerId)
    ) {
      return true;
    }

    const createdBy = classData?.createdBy;
    if (typeof createdBy === "string") {
      const createdByTrimmed = createdBy.trim();
      if (createdByTrimmed === currentUserId) return true;
      if (createdByTrimmed.toLowerCase() === "teacher" && classTeacherId && classTeacherId === currentUserId) return true;
      if (createdByTrimmed.toLowerCase() === "schooladmin" && classSchoolAdminId && classSchoolAdminId === currentUserId) return true;
      if (createdByTrimmed.toLowerCase() === "school" && classSchoolId && classSchoolId === currentUserId) return true;
    } else if (createdBy?._id && String(createdBy._id).trim() === currentUserId) {
      return true;
    }
  }

  // If none of the above matched, user does not have edit access (e.g. shared class)
  return false;
};

